import React from 'react';
import { Stack, Typography } from '@mui/material';
import gymIcon from '../assets/icons/equipment.png';
import chestIcon from '../assets/icons/chest_icon.png';
import lowerlegsIcon from '../assets/icons/lower_leg_icon.jpg';
import lowerarmsIcon from '../assets/icons/upper_arm_icon.png';
import shoulderIcon from '../assets/icons/shoulder_icon.png';
import waistIcon from '../assets/icons/waist_icon.png';
import neckIcon from '../assets/icons/neck_icon.jpg';
import cardioIcon from '../assets/icons/cardio_icon.png';
import backIcon from '../assets/icons/back_icon.png';
import armsIcon from '../assets/icons/arm_icon.png';
import upperlegsIcon from '../assets/icons/leg_icon.png';

const BodyPart = ({ item, setBodyPart, bodyPart }) => {
  let icon = null;

  // Check if the item name matches a specific value
  if (item === 'all') {
    icon = gymIcon;
  } else if (item === 'chest') {
    icon = chestIcon;
  } else if (item === 'upper legs') {
    icon = upperlegsIcon;
  } else if (item === 'lower legs') {
  icon = lowerlegsIcon;
}else if (item === 'cardio') {
  icon = cardioIcon;
}else if (item === 'upper arms') {
  icon = armsIcon;
}else if (item === 'lower arms') {
  icon = lowerarmsIcon;
}else if (item === 'neck') {
  icon = neckIcon;
}else if (item === 'back') {
  icon = backIcon;
}else if (item === 'shoulders') {
  icon = shoulderIcon;
}else if (item === 'waist') {
  icon = waistIcon;
}
  else{
    icon = gymIcon;
    
  }

  return (
    <Stack
      type="button"
      alignItems="center"
      justifyContent="center"
      className="bodyPart-card"
      sx={bodyPart === item ? { borderTop: '4px solid #90F2FF', background: '#fff', borderBottomLeftRadius: '20px', width: '270px', height: '282px', cursor: 'pointer', gap: '47px' } : { background: '#fff', borderBottomLeftRadius: '20px', width: '270px', height: '282px', cursor: 'pointer', gap: '47px' }}
      onClick={() => {
        setBodyPart(item);
        window.scrollTo({ top: 1800, left: 100, behavior: 'smooth' });
      }}
    >
      <img src={icon} alt={item} style={{ width: '40px', height: '40px', color: '#90F2FF' }} />
      <Typography fontSize="24px" fontWeight="bold" fontFamily="Alegreya" color="#3A1212" textTransform="capitalize"> {item}</Typography>
    </Stack>
  );
};

export default BodyPart;
